/* TJ independent dismissible announcement bars (latest text can show again). */
(function(){
  'use strict';
  function init(){
    var bar=document.querySelector('[data-tj-announcement]');
    if(!bar)return;
    var message=bar.getAttribute('data-tj-announcement-message')||'';
    var context=bar.getAttribute('data-tj-announcement-context')||'';
    var key='tj-announcement-dismissed:'+window.location.hostname+':'+context;
    try{if(window.localStorage.getItem(key)===message){bar.hidden=true;return;}}catch(e){}
    var close=bar.querySelector('[data-tj-announcement-close]');
    if(!close)return;
    close.addEventListener('click',function(){
      bar.hidden=true;
      try{window.localStorage.setItem(key,message)}catch(e){}
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
